import {
  Users,
  Heart,
  Music,
  BookOpen,
  Baby,
  Flame,
  Award,
  Monitor,
  DoorClosed,
  Sparkles,
  UtensilsCrossed,
  Gift,
  ShieldCheck,
} from 'lucide-react'

export interface Ministry {
  id: string
  title: string
  subtitle?: string
  shortDescription: string
  fullDescription: string
  image: string
  icon: any
  meetingTime?: string
  location?: string
  contact?: string
  features: string[]
  activities?: string[]
  targetAudience?: string
  gallery: string[]
  category?: string
}

export const ministriesData: Ministry[] = [
  // A. Spiritual Growth & Discipleship
  {
    id: 'kingdom-builders',
    title: 'Kingdom Builders – Partners',
    shortDescription:
      "Partnering with TheHousehold financially to advance God's kingdom.",
    fullDescription:
      "Kingdom Builders is our partnership ministry for those who want to sow into the vision of TheHousehold and advance God's kingdom through faithful giving. Members commit to supporting the church's mission financially and prayerfully, enabling us to expand our reach and impact.",
    image:
      'https://cdn.magicpatterns.com/uploads/97pWc4vG56uzuNDQet6zJT/KINGDOM_BUILDERS_-_WEBSITE.png',
    icon: ShieldCheck,
    meetingTime: 'Monthly partnership meetings',
    contact: 'kingdombuilders@householdchurch.org',
    category: 'spiritual-growth',
    features: [
      'Monthly partnership meetings',
      'Kingdom investment opportunities',
      'Vision casting sessions',
      'Stewardship training',
      'Special projects funding',
      'Annual appreciation events',
    ],
    activities: [
      'Financial partnership and kingdom sowing',
      'Monthly vision and update meetings',
      'Special project funding and oversight',
      'Stewardship and financial wisdom seminars',
    ],
    targetAudience:
      'For individuals and families who feel called to support the vision of TheHousehold through consistent financial partnership and prayer.',
    gallery: [
      'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },

  // B. Family & Life Ministries
  {
    id: 'marriage-ministry',
    title: 'Better Together (BT) – Marriage Ministry',
    shortDescription:
      'Building strong, Christ-centered marriages through love, unity, and purpose.',
    fullDescription:
      'Better Together is our marriage ministry dedicated to strengthening the bond between husbands and wives. We believe that a healthy marriage is the foundation of a healthy family and church. Through workshops, retreats, and fellowship events, we provide couples with biblical tools and a supportive community to grow together in love and purpose.',
    image:
      'https://cdn.magicpatterns.com/uploads/eRcNaVySFgSneVHxn1SmVP/BETTER_TOGETHER_WEBSITE_IMAGE1.png',
    icon: Heart,
    meetingTime: 'Various times - See schedule',
    location: 'TheHousehold Church',
    contact: 'marriage@householdchurch.org',
    category: 'family-life',
    features: [
      'Marriage workshops',
      'Couples retreats',
      'Date night events',
      'Biblical counseling',
      'Mentorship for newlyweds',
      'Fellowship gatherings',
    ],
    activities: [
      'Monthly couples fellowship',
      'Annual marriage retreat',
      'Marriage enrichment seminars',
      'Small group discussions',
    ],
    targetAudience:
      'For married and engaged couples looking to strengthen their relationship and build a Christ-centered home.',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/eRcNaVySFgSneVHxn1SmVP/BETTER_TOGETHER_WEBSITE_IMAGE1.png',
    ],
  },
  {
    id: 'singles-ministry',
    title: 'Before You Do (BYD) – Singles Ministry',
    shortDescription:
      'Preparing today for a God-ordained tomorrow through purpose, identity, and purity.',
    fullDescription:
      'Before You Do is our singles ministry focused on helping individuals navigate their single season with purpose and intentionality. We believe this is a vital time for personal growth, spiritual development, and preparation for future relationships. Our ministry provides a space for singles to connect, grow in their identity in Christ, and live out their destiny.',
    image:
      'https://cdn.magicpatterns.com/uploads/sYyfY7H3epHCcopD7JgihF/BEFORE_YOU_DO_IMAGE_-WEBSITE_1.png',
    icon: Sparkles,
    meetingTime: 'Various times - See schedule',
    location: 'TheHousehold Church',
    contact: 'singles@householdchurch.org',
    category: 'family-life',
    features: [
      'Identity workshops',
      'Purpose discovery',
      'Purity and boundaries training',
      'Social outings',
      'Career and life skills',
      'Mentorship',
    ],
    activities: [
      'Monthly singles gatherings',
      'Purpose-driven Bible studies',
      'Community service projects',
      'Networking and social events',
    ],
    targetAudience:
      'For single adults (ages 18+) who desire to grow in their relationship with God and live purposefully during their single season.',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/sYyfY7H3epHCcopD7JgihF/BEFORE_YOU_DO_IMAGE_-WEBSITE_1.png',
    ],
  },
  {
    id: 'mens-ministry',
    title: 'Unstoppable Men',
    shortDescription:
      'Raising strong, godly men who lead with truth, strength, and integrity.',
    fullDescription:
      "Unstoppable Men is our men's ministry committed to helping men become the spiritual leaders God has called them to be. Through regular gatherings, Bible studies, and accountability groups, we challenge men to grow in their faith, strengthen their character, and lead with integrity in every area of life.",
    image:
      'https://cdn.magicpatterns.com/uploads/8tNMGo9RoAcx8mKBh1ijG8/UNSTOPPABLE_MEN_-_WEBSITE.png',
    icon: Users,
    meetingTime: 'Saturdays @ 8:00 AM',
    location: 'TheHousehold Church',
    contact: 'men@householdchurch.org',
    category: 'family-life',
    features: [
      "Men's breakfast gatherings",
      'Accountability groups',
      'Leadership training',
      'Service projects',
      "Annual men's retreat",
      'Fatherhood resources',
    ],
    activities: [
      'Weekly Bible study and fellowship',
      'Monthly breakfast and vision meetings',
      'Mentorship for younger men',
      'Community service and church maintenance projects',
    ],
    targetAudience:
      'For men of all ages looking to grow in their faith, build brotherhood, and become effective leaders in their homes and community.',
    gallery: [
      'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'womens-ministry',
    title: 'Ladies of Excellence',
    shortDescription:
      'Empowering women to walk in grace, wisdom, and kingdom purpose.',
    fullDescription:
      "Ladies of Excellence is our women's ministry that exists to help women of all ages and stages of life connect with God and each other. Through Bible studies, prayer groups, retreats, and fellowship events, we create opportunities for women to grow spiritually, build meaningful relationships, and discover their God-given purpose.",
    image:
      'https://cdn.magicpatterns.com/uploads/qKCeFKkqGGFJ9rF2zbyHTV/LADIES_OF_EXCELLENCE_-_WEBSITE.png',
    icon: Heart,
    meetingTime: 'Various times - See schedule',
    location: 'TheHousehold Church',
    contact: 'women@householdchurch.org',
    category: 'family-life',
    features: [
      'Weekly Bible studies',
      'Monthly fellowship gatherings',
      "Annual women's retreat",
      'Prayer groups',
      'Mentorship opportunities',
      'Service projects',
    ],
    activities: [
      'Grace-filled Bible study sessions',
      'Prayer and intercession circles',
      'Hospitality and community outreach',
      'Personal development workshops',
    ],
    targetAudience:
      'For women seeking to deepen their relationship with God, find supportive community, and walk in their divine excellence.',
    gallery: [
      'https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'elderly-ministry',
    title: 'Crown of Glory – Elderly',
    shortDescription:
      'Honoring wisdom and strengthening lives with love, care, and dignity.',
    fullDescription:
      'Crown of Glory is our ministry dedicated to honoring and serving our senior members. We provide fellowship, care, and support to ensure our elders feel valued, connected, and spiritually nourished. Through visits, special events, and community, we celebrate the wisdom and legacy of our senior saints.',
    image:
      'https://cdn.magicpatterns.com/uploads/7eALzicetcBERSJwTLqJTE/CROWN_OF_GLOR-_ELDERLY_-_WEBSITE.png',
    icon: Award,
    meetingTime: 'Monthly fellowship',
    location: 'TheHousehold Church',
    contact: 'seniors@householdchurch.org',
    category: 'family-life',
    features: [
      'Monthly senior fellowship',
      'Home & hospital visits',
      'Prayer support network',
      'Special recognition events',
      'Transportation assistance',
      'Wellness check-ins',
    ],
    activities: [
      'Monthly fellowship luncheons',
      'Home visitation and care ministry',
      'Wisdom sharing and storytelling sessions',
      'Health and wellness seminars for seniors',
    ],
    targetAudience:
      'For our honored seniors (ages 60+) who desire fellowship, spiritual support, and opportunities to share their life-long wisdom.',
    gallery: [
      'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },

  // C. Youth & Children
  {
    id: 'youth-ministry',
    title: 'Ignite Youth',
    shortDescription:
      'Raising a generation on fire for God, bold in faith and purpose.',
    fullDescription:
      'Ignite is our dynamic youth ministry for middle and high school students to encounter God, build authentic friendships, and discover their purpose. Through engaging worship, relevant teaching, and meaningful small groups, we create a space where teens can ask hard questions, grow in their faith, and learn to live out their beliefs in everyday life.',
    image:
      'https://cdn.magicpatterns.com/uploads/oKPwc6HfuYyACt4QZAFom2/IGNITE_-_WEBSITE.png',
    icon: Users,
    meetingTime: 'Wednesdays @ 7:00 PM',
    location: 'TheHousehold Church - Youth Center',
    contact: 'youth@householdchurch.org',
    category: 'youth-children',
    features: [
      'Weekly youth services',
      'Small group discipleship',
      'Annual mission trips',
      'Leadership development',
      'Social events and outings',
      'Mentorship programs',
    ],
    activities: [
      'High-energy worship and relevant teaching',
      'Small group discussions and accountability',
      'Annual youth camps and retreats',
      'Talent showcases and creative arts',
    ],
    targetAudience:
      'For middle and high school students (ages 12-18) looking for a place to belong, grow, and make an impact.',
    gallery: [
      'https://images.unsplash.com/photo-1529070538774-1843cb3265df?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'childrens-ministry',
    title: 'Kingdom Kidz',
    shortDescription:
      'Nurturing young hearts to know, love, and grow in Christ.',
    fullDescription:
      "Kingdom Kidz is our vibrant children's ministry designed to help kids birth through fifth grade discover God's love in an exciting, age-appropriate way. Our dedicated team creates a safe, fun environment where children can learn biblical truths, make friends, and develop a genuine relationship with Jesus.",
    image:
      'https://cdn.magicpatterns.com/uploads/kfWPfyNKW4h2NBwAvvFhcg/KINGDOM_KIDZ_-_WEBSITE.png',
    icon: Baby,
    meetingTime: 'Sundays during service @ 10:00 AM',
    location: 'TheHousehold Church - Kids Wing',
    contact: 'kids@householdchurch.org',
    category: 'youth-children',
    features: [
      'Age-appropriate Bible lessons',
      'Interactive worship and music',
      'Safe, secure check-in system',
      'Trained and background-checked volunteers',
      'Fun games and activities',
      'Character development focus',
    ],
    activities: [
      'Interactive Bible storytelling',
      'Creative crafts and hands-on learning',
      'Kids-led worship and prayer',
      'Seasonal plays and performances',
    ],
    targetAudience:
      'For children from birth through 5th grade, providing a safe and fun environment to learn about Jesus.',
    gallery: [
      'https://images.unsplash.com/photo-1472162072942-cd5147eb3902?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },

  // D. Worship & Creative Arts
  {
    id: 'music-ministry',
    title: 'Fresh Anointing Choir - Choir',
    shortDescription:
      "Ministering God's presence through spirit-filled worship and praise.",
    fullDescription:
      "The Fresh Anointing Choir is our music ministry that brings together musicians, vocalists, and worship leaders who use their gifts to glorify God and lead our congregation into His presence. We believe worship is more than just music—it's a lifestyle of honoring God in everything we do.",
    image:
      'https://cdn.magicpatterns.com/uploads/t1KdBs84CyhCUyap6uBQdT/FRESH_ANOINTING_CHOIR_-_WEBSITE.png',
    icon: Music,
    meetingTime: 'Rehearsals: Thursdays @ 7:00 PM',
    location: 'TheHousehold Church - Main Sanctuary',
    contact: 'worship@householdchurch.org',
    category: 'worship-creative',
    features: [
      'Vocal and instrumental teams',
      'Choir rehearsals',
      'Special worship nights',
      'Recording opportunities',
      'Music training',
      'Guest worship events',
    ],
    activities: [
      'Weekly worship leading in services',
      'Intensive vocal and musical rehearsals',
      'Worship workshops and training',
      'Songwriting and recording sessions',
    ],
    targetAudience:
      'For gifted vocalists and musicians with a heart for worship and a desire to lead others into the presence of God.',
    gallery: [
      'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'tech-media',
    title: 'Sight & Sound – Media',
    shortDescription:
      'Amplifying the gospel through excellence in sound, media, and visuals.',
    fullDescription:
      'Sight & Sound is our technical and media ministry responsible for ensuring excellence in audio, visual, lighting, and digital media. From live streaming services to creating compelling graphics and managing sound, this team plays a vital role in how the gospel reaches people both in-person and online.',
    image:
      'https://cdn.magicpatterns.com/uploads/ems8oBqWefvxNNyX18sN6e/MEDIA_-_SIGHT__SOUND_-_WEBSITE.png',
    icon: Monitor,
    meetingTime: 'Sundays & Wednesdays (setup)',
    location: 'TheHousehold Church - Tech Booth',
    contact: 'media@householdchurch.org',
    category: 'worship-creative',
    features: [
      'Sound engineering',
      'Live streaming',
      'Graphic design',
      'Video production',
      'Lighting design',
      'Social media content',
    ],
    activities: [
      'Live audio mixing and sound reinforcement',
      'Video production and live stream management',
      'Visual media and projection control',
      'Digital content creation and social media management',
    ],
    targetAudience:
      'For tech-savvy individuals interested in sound, video, lighting, or digital media who want to use their skills for the Kingdom.',
    gallery: [
      'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },

  // E. Service & Hospitality
  {
    id: 'ushers-greeters',
    title: 'Ushers / Greeters',
    shortDescription:
      'Welcoming every soul with love and creating an atmosphere of honor.',
    fullDescription:
      "Our Usher and Greeter ministry is the first face of TheHousehold. From the parking lot to the sanctuary, our volunteers work together to make sure every guest feels valued and cared for. We believe that hospitality is more than just being friendly—it's about showing people the love of Christ through genuine care and attention.",
    image:
      'https://cdn.magicpatterns.com/uploads/quTLbVsjNxcWxMXP42KnHz/USHERS__GREETERS_-_WEBSITE.jpg',
    icon: DoorClosed,
    meetingTime: 'Sundays - Various shifts',
    contact: 'hospitality@householdchurch.org',
    category: 'service-hospitality',
    features: [
      'Greeting team',
      'Ushering ministry',
      'Parking assistance',
      'Guest services',
      'First-time visitor care',
      'Seating coordination',
    ],
    activities: [
      'Warmly welcoming guests and members',
      'Assisting with seating and service flow',
      'Providing information and guidance to visitors',
      'Maintaining an atmosphere of order and honor',
    ],
    targetAudience:
      'For friendly, hospitable individuals who love meeting new people and want to create a welcoming environment for all.',
    gallery: [
      'https://images.unsplash.com/photo-1561047029-3000c68339ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'sanctuary-keepers',
    title: 'Sanctuary Keepers',
    shortDescription:
      "Maintaining God's house with excellence, order, and reverence.",
    fullDescription:
      "The Sanctuary Keepers ministry is responsible for maintaining the beauty, cleanliness, and order of God's house. Our dedicated team ensures that the church environment is welcoming, organized, and prepared for worship. We take pride in creating a space that reflects the excellence and reverence of our God.",
    image:
      'https://cdn.magicpatterns.com/uploads/thdRoeGC9aGLAosUVQG98a/SANCTUARY_KEEPERS_-_WEBSITE.png',
    icon: Sparkles,
    meetingTime: 'Saturdays & as needed',
    location: 'TheHousehold Church',
    contact: 'sanctuary@householdchurch.org',
    category: 'service-hospitality',
    features: [
      'Church cleaning and setup',
      'Sanctuary preparation',
      'Communion setup',
      'Event setup and teardown',
      'Facility maintenance coordination',
      'Decoration and beautification',
    ],
    activities: [
      'Detailed cleaning and care of the sanctuary',
      'Preparing the space for weekly services',
      'Setting up for communion and special events',
      'Beautifying the church environment',
    ],
    targetAudience:
      'For those who have a heart for service and want to honor God by caring for His physical house with excellence.',
    gallery: [
      'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },

  // F. Outreach & Community Impact
  {
    id: 'food-distribution',
    title: "Steven's Squad – Food Distribution",
    shortDescription:
      'Serving and distributing food with love, dignity, and compassion.',
    fullDescription:
      "Steven's Squad is our food distribution ministry that serves families in need within our community. Named after the biblical Stephen who served with grace and power, this ministry organizes regular food drives, distributions, and partnerships with local organizations to ensure no one goes hungry.",
    image:
      'https://cdn.magicpatterns.com/uploads/sBD59TReirqYjx5tJox42g/STEVENS_SQUAD_-_WEBSITE.png',
    icon: UtensilsCrossed,
    meetingTime: 'Monthly distributions',
    location: 'Various community locations',
    contact: 'outreach@householdchurch.org',
    category: 'outreach',
    features: [
      'Monthly food distributions',
      'Community food drives',
      'Partnership with food banks',
      'Holiday meal programs',
      'Volunteer coordination',
      'Family support services',
    ],
    activities: [
      'Organizing and sorting food donations',
      'Coordinating monthly distribution events',
      'Partnering with local food banks and suppliers',
      'Providing nutritional support to families in need',
    ],
    targetAudience:
      'For compassionate individuals who want to fight hunger and serve the local community with practical love.',
    gallery: [
      'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
  {
    id: 'charity-friends-of-tabitha',
    title: 'Friends of Tabitha – Charity',
    shortDescription:
      'Extending love and support to those in need through acts of kindness.',
    fullDescription:
      "Friends of Tabitha is our charity ministry inspired by the biblical Tabitha (Dorcas) who was known for her good works and acts of charity. This ministry extends practical love and support to those in need through clothing drives, financial assistance, community care packages, and various acts of kindness that reflect Christ's love.",
    image:
      'https://cdn.magicpatterns.com/uploads/acP32gFi73Jnu5wKaNoRFz/FRIENDS_OF_TABITHA_-_CHARITY_-_WEBSITE.png',
    icon: Gift,
    meetingTime: 'Monthly outreach events',
    location: 'Various community locations',
    contact: 'charity@householdchurch.org',
    category: 'outreach',
    features: [
      'Clothing drives',
      'Financial assistance programs',
      'Community care packages',
      'Back-to-school drives',
      'Holiday giving programs',
      'Widow and orphan support',
    ],
    activities: [
      'Coordinating clothing and resource drives',
      'Providing assistance to widows and orphans',
      'Assembling and delivering care packages',
      'Organizing seasonal charity events',
    ],
    targetAudience:
      'For those with a heart for charity and a desire to meet the practical needs of the vulnerable in our community.',
    gallery: [
      'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },

  // Keep Deep Dive as a standalone for the dedicated page
  {
    id: 'deep-dive',
    title: 'Deep Dive Bible Study',
    shortDescription:
      "Deep Dive into God's Word every Sunday morning. These sessions foster discussion, learning, and spiritual maturity.",
    fullDescription:
      "Deep Dive is our dedicated Bible Study experience designed to help you dig deeper into Scripture in a focused, intimate setting. Every Sunday morning before our main service, we gather to study God's Word together, ask questions, share insights, and grow alongside others who are hungry for God's truth.",
    image:
      'https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    icon: BookOpen,
    meetingTime: 'Sundays @ 9:00 AM',
    location: 'TheHousehold Church',
    contact: 'deepdive@householdchurch.org',
    category: 'spiritual-growth',
    features: [
      'Weekly Bible study sessions',
      'Discussion-based format',
      'Study materials provided',
      'All ages welcome',
      'Online resources available',
      'Assessment & growth tracking',
    ],
    activities: [
      'In-depth scriptural analysis',
      'Interactive Q&A sessions',
      'Practical life applications',
      'Weekly study materials',
    ],
    targetAudience:
      'For anyone hungry for a deeper understanding of the Word of God and looking for interactive spiritual growth.',
    gallery: [
      'https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ],
  },
]
